import script from "./Orderlists.vue?vue&type=script&setup=true&lang=js"
export * from "./Orderlists.vue?vue&type=script&setup=true&lang=js"

import "./Orderlists.vue?vue&type=style&index=0&id=c237239a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c237239a"]])

export default __exports__